// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"25825":"2bd1ca33b78681070348","38532":"7b740a631775e59a754f","80020":"3fecb2cf380d152c4fce"}[chunkId] + ".css";
};